export function getValue(option) {
  return option?.id
}

export function getLabel(option) {
  return option?.name
}
